export class CreateTaxiVehicleModel {
	Id?: number;
	Year: number | null;
	BrandId: number | null;
	ModelId: number | null;
	ChassisNumber: string;
	NumberPlate: string;
	LTFRBCaseNumber: string;

	constructor(payload?: { [key: string]: any }) {
		this.Year = null;
		this.BrandId = null;
		this.ModelId = null;
		this.ChassisNumber = '';
		this.NumberPlate = '';
		this.LTFRBCaseNumber = '';
		Object.assign(this, payload);
	}

	public IsAllFieldsFilled(): boolean {
		if (this.Year && this.BrandId &&
			this.ModelId && this.ChassisNumber &&
			this.NumberPlate && this.LTFRBCaseNumber) {
			return true;
		}

		return false;
	}
}
